<div *ngIf="version !== null">
  <div class="changelogs-details-menu-header">
    <span class="changelogs-details-menu-item-text">Détails de la version</span>
  </div>
  <table class="changelogs-details-menu-list changelogs-menu-list-open">
    <tbody>
      <tr *ngFor="let evolution of version.evolutions">
        <td [innerHTML]="splitDetailsIntoColumns(evolution, 1)"></td>
        <td>
          <span
            class="changelogs-details-menu-item-text"
            [innerHTML]="splitDetailsIntoColumns(evolution, 0)"></span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
